<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Complaint Management" title="Complaint Details" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">

                                <div class="col-12">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i>Back</a>

                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Job Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">IMEI</th>
                                                        <th>:</th>
                                                        <td>{{ service.device ? service.device.imei : '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">ICCID</th>
                                                        <th>:</th>
                                                        <td>{{ service.device ? service.device.iccid : '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">SIM Provider</th>
                                                        <th>:</th>
                                                        <td>{{ service.device ? service.device.sim_provider : '-' }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Vehicle Number</th>
                                                        <th>:</th>
                                                        <td>{{service.vehicle_no}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Contact</th>
                                                        <th>:</th>
                                                        <td>{{service.mobile}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Complaint Type</th>
                                                        <th>:</th>
                                                        <td><b>{{service.service_type == 1 ? 'SIM Change' : service.service_type == 2 ? 'Repair' : service_type ==3 ? 'Replacement' : service.service_type == 4 ? 'No Data' : service.service_type == 5 ? 'Tracking Issue' : service.service_type == 6 ? 'Hardware Issue' : service.service_type == 7 ? 'Software Issue' : service.service_type == 8 ? 'Alert Fail' : service.service_type == 9 ? 'Other' : service.service_type == 10 ? 'Renewal Replacement' : 'N/A'}}</b></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Details</th>
                                                        <th>:</th>
                                                        <td>{{service.details}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Created Date</th>
                                                        <th>:</th>
                                                        <td>{{$filters.formatDate(service.created_date)}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Completed Date</th>
                                                        <th>:</th>
                                                        <td>{{$filters.formatDate(service.completed_date)}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Status</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span class="badge rounded-pill bg-warning" v-if="service.status == 1">Pending</span>
                                                            <span class="badge rounded-pill bg-info" v-if="service.status == 2">Ongoing</span>
                                                            <span class="badge rounded-pill bg-success" v-if="service.status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-info" v-if="service.status == 4">Assigned to vendor</span>
                                                            <span class="badge rounded-pill bg-primary" v-if="service.status == 5">Component Replaced</span>
                                                            <span class="badge rounded-pill bg-light" v-if="service.status == 6">SIM Changed</span>
                                                            <span class="badge rounded-pill bg-secondary" v-if="service.status == 7">Device Replaced</span>
                                                            <span class="badge rounded-pill bg-success" v-if="service.status == 8">Renewal Replacement Device Received</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Added By</th>
                                                        <th>:</th>
                                                        <td>{{service.added_user_name}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>

                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-3">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Complaint Logs</h4>

                                        <div class="table-responsive product-table">
                                            <table class="display" id="basic-1">
                                                <thead>
                                                    <tr align="center">
                                                        <th>Sl.No</th>  
                                                        <th>Date</th>
                                                        <th>Staff</th>
                                                        <th>Status</th>
                                                        <th>Vendor</th>
                                                        <th>Remarks</th>
                                                        <th>Raw Materials Used</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="Boolean(complaint_logs.length)">
                                                    <tr align="center" v-for="(log,index) in complaint_logs" :key="log.id">
                                                        <td>{{index+1}}</td>
                                                        <td>{{$filters.formatDateTime(log.log_created_at)}}</td>
                                                        <td>{{log.done_by}}</td>
                                                        <td>
                                                            <span class="badge rounded-pill bg-warning" v-if="log.log_status == 1">Created</span>
                                                            <span class="badge rounded-pill bg-info" v-if="log.log_status == 2">Ongoing</span>
                                                            <span class="badge rounded-pill bg-success" v-if="log.log_status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-danger" v-if="log.log_status == 4">Assigned to vendor</span>
                                                            <span class="badge rounded-pill bg-primary" v-if="log.log_status == 5">Component Replaced</span>
                                                            <span class="badge rounded-pill bg-info" v-if="log.log_status == 6">SIM Changed</span>
                                                            <span class="badge rounded-pill bg-secondary" v-if="log.log_status == 7">Device Replaced</span>
                                                            <span class="badge rounded-pill bg-success" v-if="log.log_status == 8">Renewal Replacement Device Received</span>
                                                            <span class="badge rounded-pill bg-danger" v-if="log.log_status == 9">Revoked</span>
                                                            <span class="badge rounded-pill bg-warning" v-if="log.log_status == 10">Updated</span>
                                                        </td>
                                                        <td>{{log.vendor_name}}</td>
                                                        <td>{{log.remarks}}</td>
                                                        <td>
                                                            <div v-if="log.materials_used && log.materials_used.length">
                                                                <div
                                                                v-for="(material, mIndex) in log.materials_used"
                                                                :key="mIndex"
                                                                >
                                                                {{ material.raw_material_name }} - {{ material.quantity }}
                                                                </div>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </td>
                                                    </tr>
                                                   
                                                
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="12" align="center">No data available in the table</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>	
</template>

<script>

   export default {
		name: "Job Details",
        
		data() {
			return {
				keyword: "",
				showsearch: false,
				listing_length: 10,

				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,

                status_type: "",

                vendor_id: "",

                complaint_logs:[],
                service:{},
                
			};
		},
        created(){
            this.completedDetail();
        },

        methods: {

            getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            completedDetail(page_url = null) {
				this.getToken();
				let url = '/staffs/completedServiceDetail?service_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
                        this.service = responseData.service;
                        this.complaint_logs = responseData.complaint_logs;
					})
					.catch((err) => console.log(err));
			},

        }

        

   }


</script>